class Browser {
  static isWechat() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
}
export default Browser;



// WEBPACK FOOTER //
// ./src/wechat.js